import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RootApp from './RootApp';
import { UserProvider } from './component/LoginContext/UserContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { VideoProvider } from './Pages/VideoPlayer/VideoContext';
import './config/sentry';
import * as Sentry from '@sentry/react';

if (window.Chargebee) {
  window.Chargebee.init({
    site: import.meta.env.VITE_CHARGEBEE_SITE,
    publishableKey: import.meta.env.VITE_APP_CHARGEBEE_API_KEY
  });
} else {
  console.error("Chargebee script failed to load!");
}

// Wrap RootApp with Sentry's error boundary and profiler
const SentryRootApp = Sentry.withProfiler(RootApp);

ReactDOM.createRoot(document.getElementById('root')).render(
	<UserProvider>
		<VideoProvider>
			<ToastContainer />
			<SentryRootApp />
		</VideoProvider>
	</UserProvider>
);
